import { render, staticRenderFns } from "./ParamDict.vue?vue&type=template&id=4c6bf18b&scoped=true"
import script from "./ParamDict.vue?vue&type=script&lang=js"
export * from "./ParamDict.vue?vue&type=script&lang=js"
import style0 from "./ParamDict.vue?vue&type=style&index=0&id=4c6bf18b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6bf18b",
  null
  
)

export default component.exports